<template>
  <div>
    <DateFilter
      v-model="selectedDate"
      class="mt-3"
      :default-filter="'today'"
      @changeDate="reCallData()"
    ></DateFilter>
    <v-layout justify-end align-content-end align-end>
      <v-btn outline color="primary" @click="showSearch = !showSearch"
        ><v-icon small>search</v-icon> Search</v-btn
      >
      <v-btn outline color="primary" :loading="loading" @click="exportRankingReport()"
        >Export</v-btn
      >
    </v-layout>
    <v-card v-if="showSearch" class="mt-2 mb-2" style="padding: 12px">
      <v-layout row wrap class="form-control">
        <v-flex xs6 sm4 px-2>
          <div class="caption">Issue ID</div>
          <input v-model="filter.id" type="text" placeholder="Issue ID" />
        </v-flex>
        <v-flex xs6 sm4 px-2>
          <div class="caption">Topic</div>
          <input v-model="filter.topic" type="text" placeholder="Topic" />
        </v-flex>
        <v-flex xs6 sm4 px-2>
          <div class="caption">Position</div>
          <input v-model="filter.position" type="text" placeholder="Position" />
        </v-flex>
        <v-flex xs6 sm4 px-2>
          <div class="caption">Dept.</div>
          <input v-model="filter.department" type="text" placeholder="Department" />
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-end align-end align-content-end>
        <v-btn outline color="grey" @click="clearSearch">{{ $t('Clear Search') }}</v-btn>
        <v-btn depressed color="primary" @click="handleSearch">Search</v-btn>
      </v-layout>
    </v-card>
    <v-pagination
      v-model="pageNumber"
      class="mt-3 mb-3"
      :length="pageLength"
      @input="changePage"
    ></v-pagination>
    <v-card>
      <v-data-table :loading="loading" hide-actions :headers="headers" :items="issueData">
        <template #items="props">
          <tr style="cursor: pointer" @click="handleShowModalDetail(props.item)">
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.employee_id }}</td>
            <td>{{ props.item.timestamp | DateFormat('DD/MM/YYYY HH:mm') }}</td>
            <td>{{ props.item.topic }}</td>
            <td>{{ [props.item.first_name, props.item.last_name].join(' ').trim() }}</td>
            <td>{{ props.item.position }}</td>
            <td>{{ props.item.department }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <ModalReport
      v-if="showModalDetail && selectReport"
      :value="showModalDetail"
      :data="selectReport"
      @input="(value) => (showModalDetail = value)"
    />
  </div>
</template>

<script>
import moment from 'moment'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import { mapGetters } from 'vuex'
import ModalReport from './ModalReport'
import tigerpolyApi from '../../../../../../api/tigerpoly'
import XLSX from 'xlsx'

const baseFilter = {
  id: '',
  topic: '',
  position: '',
  department: ''
}

export default {
  components: { ModalReport, DateFilter },
  data() {
    return {
      showSearch: false,
      pageNumber: 1,
      rowPerPage: 10,
      total: 0,
      loading: false,
      filter: { ...baseFilter },
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      issueData: [],
      totalAllReports: 0,
      headers: [
        { text: 'Issue ID', value: 'id', sortable: false },
        { text: 'EMP.ID', value: 'employee_id', sortable: false },
        { text: 'Date', value: 'timestamp', sortable: false },
        { text: 'Topic', value: 'topic', sortable: false },
        { text: 'ชื่อผู้แจ้ง', value: 'full_name', sortable: false },
        { text: 'ตำแหน่งของผู้แจ้ง', value: 'position', sortable: false },
        { text: 'แผนกของผู้แจ้ง', value: 'department', sortable: false }
      ],
      showModalDetail: false,
      selectReport: null
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    limit() {
      return this.rowPerPage
    },
    offset() {
      return this.rowPerPage * this.pageNumber - this.rowPerPage
    },
    pageLength() {
      if (!this.total) return 0
      return Math.ceil(this.total / this.rowPerPage)
    }
  },
  methods: {
    async init() {
      this.reCallData()
    },
    async reCallData() {
      try {
        const { data, total } = await this.fetchReport()
        if (data) {
          this.issueData = data
          this.total = total
        } else {
          this.issueData = []
          this.total = 0
        }
      } catch (error) {
        this.issueData = []
        this.total = 0
      }
    },
    handleShowModalDetail(reportData) {
      this.selectReport = reportData
      this.showModalDetail = true
    },
    changePage() {
      this.reCallData()
    },
    clearSearch() {
      this.filter = { ...baseFilter }
      this.reCallData()
    },
    handleSearch() {
      this.reCallData()
    },
    async fetchReport(isExport = false) {
      try {
        this.loading = true
        const config = {
          params: {
            page_id: this.selectedBot.pageid,
            datefrom: this.selectedDate.start,
            dateto: this.selectedDate.end,
            limit: isExport ? 999999 : this.limit,
            offset: isExport ? 0 : this.offset,
            ...this.filter
          }
        }
        const response = await tigerpolyApi.getReport(config)
        return response.data
      } catch (error) {
        console.error(error)
        this.$swal.fire({
          text: 'เรียกข้อมูลไม่สำเร็จ',
          type: 'error'
        })
        throw error
      } finally {
        this.loading = false
      }
    },
    async exportRankingReport() {
      try {
        const { data } = await this.fetchReport(true)
        const filename = 'issue_report'
        const rows = []
        rows.push(['Issue Report', '', '', '', '', '', '', ''])
        rows.push([
          `Filter Date From ${moment(this.selectedDate.start).format('DD/MM/YYYY')} - ${moment(
            this.selectedDate.end
          ).format('DD/MM/YYYY')}`,
          '',
          '',
          ''
        ])
        rows.push(['', '', '', '', '', '', '', ''])
        rows.push([
          'No.',
          'Issue ID',
          'Date',
          'Topic',
          'The accused',
          'Position',
          'Dept.',
          'Complainment'
        ])
        for (let i = 0; i < data.length; i++) {
          const issueData = data[i]
          rows.push([
            i + 1,
            issueData.id,
            issueData.timestamp ? moment(issueData.timestamp).format('DD/MM/YYYY HH:mm') : '-',
            issueData.topic,
            [issueData.first_name, issueData.last_name].join(' ').trim(),
            issueData.position,
            issueData.department,
            issueData.detail
          ])
        }
        const wb = XLSX.utils.book_new()
        const dataWS = XLSX.utils.aoa_to_sheet(rows)
        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(wb, `${filename}.xlsx`)
      } catch (error) {
        this.$swal.fire({
          text: 'เรียกข้อมูลไม่สำเร็จ',
          type: 'error'
        })
        console.error(error)
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/view/template/tigerpoly/reporting/issueReport/IssueReport.vue